import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import axios from 'axios';
import { saveSessionToken } from '../lib/auth';

const API = `${window.location.origin}/api`;

const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          console.error('No session_id found in URL');
          navigate('/login');
          return;
        }

        const sessionId = sessionIdMatch[1];
        
        // Exchange session_id for session_token
        const response = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );

        const user = response.data;
        
        // Save Bearer token for future requests
        if (user.session_token) {
          saveSessionToken(user.session_token);
        }
        
        // Clear the hash from URL
        window.history.replaceState(null, '', window.location.pathname);
        
        // Check for custom redirect (e.g., from reservation page)
        const customRedirect = localStorage.getItem('auth_redirect');
        if (customRedirect) {
          localStorage.removeItem('auth_redirect');
          navigate(customRedirect);
          return;
        }
        
        // Redirect based on user role
        if (user.is_admin) {
          navigate('/admin', { state: { user } });
        } else {
          navigate('/dashboard', { state: { user } });
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/login');
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-black flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-12 h-12 text-[#DFFF00] mx-auto mb-4 animate-spin" />
        <p className="text-white text-lg">Connexion en cours...</p>
        <p className="text-slate-400 text-sm mt-2">Veuillez patienter</p>
      </div>
    </div>
  );
};

export default AuthCallback;
